import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import InfoIcon from "@material-ui/icons/Info";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import moment from "moment-timezone";
import React from "react";
import DefaultFases from "../../constants/DefaultFases";
import { languages } from "../../constants/languages";
export default class SubmitResultDialog extends React.Component {
  state = {
    value: 0,
    expandedHistory: false,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      // enter was pressed
      e.preventDefault();
      if (
        !(
          this.props.submitDisabled ||
          (this.props.missingTeams &&
            this.props.match.score1 !== null &&
            this.props.match.score2 !== null &&
            this.props.score1 !== null &&
            this.props.score2 !== null)
        )
      ) {
        this.props.handleSubmit(e);
      }
    }
  };

  render() {
    let phaseFinished = false;
    const division = this.props.divisionsObject[this.props.poule.division];
    if (
      division &&
      (division.fases || DefaultFases)[this.props.fase + 1] &&
      (division.fases || DefaultFases)[this.props.fase + 1].started
    ) {
      phaseFinished = true;
    }

    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
        maxWidth={false}
      >
        <DialogTitle id="form-dialog-title" className="results-dialog">
          {languages.results.submitResult}
        </DialogTitle>
        {this.props.missingTeams &&
        this.props.match.score1 === null &&
        this.props.match.score2 === null ? (
          <DialogContent style={{ paddingTop: 0 }}>
            {this.props.fase === 0
              ? languages.formatString(
                  languages.results.missingTeamsWarning,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )
              : languages.results.startFaseFirst}
          </DialogContent>
        ) : (
          <div>
            {this.props.showPlayerStats && (
              <Tabs
                value={this.state.value}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
                scrollButtons="off"
                variant="fullWidth"
                style={{ marginBottom: 10 }}
              >
                <Tab
                  key={0}
                  label={languages.tournament.teams}
                  style={{ height: 40 }}
                />
                <Tab
                  key={1}
                  label={languages.tournament.players}
                  style={{ height: 40 }}
                />
              </Tabs>
            )}
            {this.state.value === 0 && (
              <DialogContent style={{ paddingTop: 0 }}>
                {(this.props.scoring.useSets || "0") === "0" ? (
                  <div>
                    {this.props.showCheckboxes && (
                      <DialogContentText style={{ paddingBottom: 5 }}>
                        {languages.results.markWinner}
                      </DialogContentText>
                    )}
                    <div style={{ display: "flex" }}>
                      <TextField
                        autoFocus
                        margin="dense"
                        label={
                          (this.props.team1 || "").length > 30
                            ? this.props.team1.substr(0, 30 - 1) + "..."
                            : this.props.team1
                        }
                        defaultValue={
                          this.props.score1 !== null ? this.props.score1 : ""
                        }
                        name="score1"
                        onChange={this.props.handleScoreChange}
                        type="number"
                        inputProps={{ inputMode: "numeric" }}
                        style={{ width: "100%" }}
                        onKeyDown={this.handleKeyDown}
                      />
                      {this.props.showCheckboxes && (
                        <Checkbox
                          name={this.props.match.team1.toString()}
                          checked={
                            this.props.winner ===
                            this.props.match.team1.toString()
                          }
                          onClick={this.props.handleCheck}
                          color="primary"
                        />
                      )}
                    </div>
                    <br />
                    <div style={{ display: "flex" }}>
                      <TextField
                        margin="dense"
                        label={
                          (this.props.team2 || "").length > 30
                            ? this.props.team2.substr(0, 30 - 1) + "..."
                            : this.props.team2
                        }
                        defaultValue={
                          this.props.score2 !== null ? this.props.score2 : ""
                        }
                        name="score2"
                        onChange={this.props.handleScoreChange}
                        type="number"
                        inputProps={{ inputMode: "numeric" }}
                        style={{ width: "100%" }}
                        onKeyDown={this.handleKeyDown}
                      />
                      {this.props.showCheckboxes && (
                        <Checkbox
                          name={this.props.match.team2.toString()}
                          checked={
                            this.props.winner ===
                            this.props.match.team2.toString()
                          }
                          onClick={this.props.handleCheck}
                          color="primary"
                        />
                      )}
                    </div>
                    {this.props.showPenalties && (
                      <div style={{ marginTop: 15 }}>
                        <div style={{ fontWeight: "bold" }}>
                          {languages.results.penaltyShootout}
                        </div>
                        <div>
                          <TextField
                            margin="dense"
                            label={
                              (this.props.team1 || "").length > 30
                                ? this.props.team1.substr(0, 30 - 1) + "..."
                                : this.props.team1
                            }
                            value={
                              this.props.penalties1 !== null
                                ? this.props.penalties1
                                : ""
                            }
                            name="penalties1"
                            onChange={this.props.handlePenaltiesChange}
                            type="number"
                            inputProps={{ inputMode: "numeric" }}
                            style={{ width: "100%" }}
                            onKeyDown={this.handleKeyDown}
                          />
                        </div>
                        <div>
                          <TextField
                            margin="dense"
                            label={
                              (this.props.team2 || "").length > 30
                                ? this.props.team2.substr(0, 30 - 1) + "..."
                                : this.props.team2
                            }
                            value={
                              this.props.penalties2 !== null
                                ? this.props.penalties2
                                : ""
                            }
                            name="penalties2"
                            onChange={this.props.handlePenaltiesChange}
                            type="number"
                            inputProps={{ inputMode: "numeric" }}
                            style={{ width: "100%" }}
                            onKeyDown={this.handleKeyDown}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    {this.props.showCheckboxes && (
                      <DialogContentText style={{ paddingBottom: 5 }}>
                        {languages.results.markWinner}
                      </DialogContentText>
                    )}
                    {(this.props.scoring.setsType || "0") === "0" && (
                      <div style={{ marginBottom: 20 }}>
                        {languages.results.intermediateResults +
                          ": " +
                          this.props.gameResultsState.result1 +
                          " - " +
                          this.props.gameResultsState.result2}
                      </div>
                    )}
                    <div
                      style={{ display: "flex", flexWrap: "wrap", margin: -10 }}
                    >
                      {(() => {
                        const hasDecidingSet =
                          !!this.props.scoring.decidingSet &&
                          !!this.props.gameResultsState.decidingSet;
                        return this.props.setsArray.map((i) => {
                        let score1 = (this.props.sets[i] || {}).score1
                          ? (this.props.sets[i] || {}).score1
                          : "";
                        let score2 = (this.props.sets[i] || {}).score2
                          ? (this.props.sets[i] || {}).score2
                          : "";
                        const showCheckboxOnThisSet =
                          this.props.showCheckboxes &&
                          i === this.props.setsArray.length - 1 &&
                          !hasDecidingSet;
                        return (
                          <div key={i} className="setScore">
                            <div>
                              <b>
                                {languages.results.set +
                                  " " +
                                  (i + 1).toString()}
                              </b>
                            </div>
                            <div style={{ display: "flex" }}>
                              <TextField
                                margin="dense"
                                label={
                                  (this.props.team1 || "").length > 15
                                    ? this.props.team1.substr(0, 15 - 1) + "..."
                                    : this.props.team1
                                }
                                defaultValue={score1}
                                name="score1"
                                onChange={(e) => {
                                  this.props.handleSetsChange(e, i);
                                }}
                                type="number"
                                inputProps={{ inputMode: "numeric" }}
                                style={{ width: "100%" }}
                                disabled={
                                  ((i >
                                    this.props.gameResultsState.numSetsPlayed &&
                                    this.props.scoring.playOff &&
                                    (this.props.scoring.setsType || 0) === 0) ||
                                    (i ===
                                      this.props.gameResultsState
                                        .numSetsPlayed &&
                                      this.props.scoring.playOff &&
                                      this.props.gameResultsState.finished &&
                                      (this.props.scoring.setsType || 0) ===
                                        0)) &&
                                  !score1
                                }
                              />
                              {showCheckboxOnThisSet && (
                                  <Checkbox
                                    name={this.props.match.team1.toString()}
                                    checked={
                                      this.props.winner ===
                                      this.props.match.team1.toString()
                                    }
                                    onClick={this.props.handleCheck}
                                    color="primary"
                                  />
                                )}
                            </div>

                            <div style={{ display: "flex" }}>
                              <TextField
                                margin="dense"
                                label={
                                  (this.props.team2 || "").length > 15
                                    ? this.props.team2.substr(0, 15 - 1) + "..."
                                    : this.props.team2
                                }
                                defaultValue={score2}
                                name="score2"
                                onChange={(e) => {
                                  this.props.handleSetsChange(e, i);
                                }}
                                type="number"
                                inputProps={{ inputMode: "numeric" }}
                                style={{ width: "100%" }}
                                disabled={
                                  ((i >
                                    this.props.gameResultsState.numSetsPlayed &&
                                    this.props.scoring.playOff &&
                                    (this.props.scoring.setsType || 0) === 0) ||
                                    (i ===
                                      this.props.gameResultsState
                                        .numSetsPlayed &&
                                      this.props.scoring.playOff &&
                                      this.props.gameResultsState.finished &&
                                      (this.props.scoring.setsType || 0) ===
                                        0)) &&
                                  !score2
                                }
                              />
                              {showCheckboxOnThisSet && (
                                  <Checkbox
                                    name={this.props.match.team2.toString()}
                                    checked={
                                      this.props.winner ===
                                      this.props.match.team2.toString()
                                    }
                                    onClick={this.props.handleCheck}
                                    color="primary"
                                  />
                                )}
                            </div>
                          </div>
                        );
                        });
                      })()}

                      {this.props.scoring.decidingSet &&
                        this.props.gameResultsState.decidingSet && (
                          <div className="setScore">
                            <div>
                              <b>{languages.structure.decidingSet}</b>
                            </div>
                            <div style={{ display: "flex" }}>
                              <TextField
                                margin="dense"
                                label={
                                  (this.props.team1 || "").length > 15
                                    ? this.props.team1.substr(0, 15 - 1) + "..."
                                    : this.props.team1
                                }
                                defaultValue={
                                  (
                                    this.props.sets[
                                      Number(this.props.scoring.numSets || "2")
                                    ] || {}
                                  ).score1
                                    ? (
                                        this.props.sets[
                                          Number(
                                            this.props.scoring.numSets || "2"
                                          )
                                        ] || {}
                                      ).score1
                                    : ""
                                }
                                name="score1"
                                onChange={(e) => {
                                  this.props.handleSetsChange(
                                    e,
                                    Number(this.props.scoring.numSets || "2")
                                  );
                                }}
                                type="number"
                                inputProps={{ inputMode: "numeric" }}
                                style={{ width: "100%" }}
                              />
                              {this.props.showCheckboxes && (
                                <Checkbox
                                  name={this.props.match.team1.toString()}
                                  checked={
                                    this.props.winner ===
                                    this.props.match.team1.toString()
                                  }
                                  onClick={this.props.handleCheck}
                                  color="primary"
                                />
                              )}
                            </div>

                            <div style={{ display: "flex" }}>
                              <TextField
                                margin="dense"
                                label={
                                  (this.props.team2 || "").length > 15
                                    ? this.props.team2.substr(0, 15 - 1) + "..."
                                    : this.props.team2
                                }
                                defaultValue={
                                  (
                                    this.props.sets[
                                      Number(this.props.scoring.numSets || "2")
                                    ] || {}
                                  ).score2
                                    ? (
                                        this.props.sets[
                                          Number(
                                            this.props.scoring.numSets || "2"
                                          )
                                        ] || {}
                                      ).score2
                                    : ""
                                }
                                name="score2"
                                onChange={(e) => {
                                  this.props.handleSetsChange(
                                    e,
                                    Number(this.props.scoring.numSets || "2")
                                  );
                                }}
                                type="number"
                                inputProps={{ inputMode: "numeric" }}
                                style={{ width: "100%" }}
                              />
                              {this.props.showCheckboxes && (
                                <Checkbox
                                  name={this.props.match.team2.toString()}
                                  checked={
                                    this.props.winner ===
                                    this.props.match.team2.toString()
                                  }
                                  onClick={this.props.handleCheck}
                                  color="primary"
                                />
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                )}
                {Object.keys(this.props.tournament.customPoints || {}).length >
                  0 && (
                  <div>
                    {/* <div style={{ fontWeight: "bold" }}>
                    {languages.structure.morePoints}
                  </div> */}
                    {Object.keys(this.props.tournament.customPoints || {}).map(
                      (key) => {
                        let customPoints =
                          this.props.tournament.customPoints[key];
                        return (
                          <div key={key} style={{ marginTop: 25 }}>
                            <div style={{ fontWeight: "bold" }}>
                              {customPoints.name}
                            </div>
                            <TextField
                              margin="dense"
                              label={
                                (this.props.team1 || "").length > 30
                                  ? this.props.team1.substr(0, 30 - 1) + "..."
                                  : this.props.team1
                              }
                              value={this.props.extra1[key] || ""}
                              name={key}
                              onChange={(e) => {
                                this.props.handleExtraChange(e, 1);
                              }}
                              type="number"
                              inputProps={{ inputMode: "numeric" }}
                              style={{ width: "100%" }}
                            />

                            <TextField
                              margin="dense"
                              label={
                                (this.props.team2 || "").length > 30
                                  ? this.props.team2.substr(0, 30 - 1) + "..."
                                  : this.props.team2
                              }
                              value={this.props.extra2[key] || ""}
                              name={key}
                              onChange={(e) => {
                                this.props.handleExtraChange(e, 2);
                              }}
                              type="number"
                              inputProps={{ inputMode: "numeric" }}
                              style={{ width: "100%" }}
                            />
                          </div>
                        );
                      }
                    )}
                  </div>
                )}

                {/* Submit history */}
                <div style={{ marginTop: 20, position: "relative" }}>
                  {phaseFinished && (
                    <div>
                      <Typography
                        style={{
                          background: "#ef9a9a",
                          padding: 10,
                          borderRadius: 5,
                          marginBottom: 5,
                          fontSize: 12,
                          fontWeight: 500,
                          display: "flex",
                        }}
                      >
                        <InfoIcon
                          style={{
                            height: 15,
                            width: 15,
                            top: 2,
                            marginRight: 5,
                            position: "relative",
                          }}
                        />
                        {languages.results.phaseFinished}
                      </Typography>
                    </div>
                  )}

                  <div
                    style={{
                      position: "relative",
                      height: !this.state.expandedHistory
                        ? 50 +
                          7 * Object.keys(this.props.match.history || {}).length
                        : "auto",
                      display:
                        Object.keys(this.props.match.history || {}).length > 0
                          ? "block"
                          : "none",
                    }}
                  >
                    {Object.keys(this.props.match.history || {})
                      .sort((a, b) => b - a)
                      .map((h, index, array) => {
                        let historyItem = this.props.match.history[h];
                        let name = "";
                        if (historyItem.as === "referee") {
                          name =
                            (this.props.refereesByKey[historyItem.asId] || {})
                              .name || "";
                        } else if (historyItem.as === "team") {
                          if (historyItem.asId === this.props.team1Id) {
                            name = this.props.team1;
                          }
                          if (historyItem.asId === this.props.team2Id) {
                            name = this.props.team2;
                          }
                        } else if (historyItem.as === "admin") {
                          name = languages.results.admin;
                        }

                        let dateTimestamp = "";
                        let dateTime = "";
                        if (
                          historyItem.timestamp &&
                          historyItem.timestamp.toDate
                        ) {
                          dateTimestamp = moment(
                            historyItem.timestamp.toDate()
                          ).unix();
                          dateTime = moment
                            .unix(dateTimestamp)
                            .format(languages.results.submitHistoryDateFormat);
                        }

                        const useSets =
                          (this.props.scoring.useSets || "0") === "1";
                        let scoreCleared = false;
                        if (
                          historyItem.as === "admin" &&
                          (useSets
                            ? JSON.stringify(historyItem.sets || {}) ===
                              JSON.stringify({})
                            : historyItem.score1 === null &&
                              historyItem.score2 === null)
                        ) {
                          scoreCleared = true;
                        }

                        let setsString = "";
                        if (useSets) {
                          Object.keys(historyItem.sets || {}).forEach(
                            (key, i) => {
                              let set = historyItem.sets[key];
                              if (set.score1 !== null && set.score2 !== null) {
                                setsString +=
                                  (i > 0 ? ", " : "") +
                                  set.score1 +
                                  "-" +
                                  set.score2;
                              }
                            }
                          );
                        }

                        let extra1 = historyItem.extra1 || {};
                        let extra2 = historyItem.extra2 || {};

                        let customPointsString = " ";
                        Object.keys(
                          this.props.tournament.customPoints || {}
                        ).forEach((key) => {
                          let customPoints =
                            this.props.tournament.customPoints[key];
                          if (
                            (extra1[key] || extra2[key]) &&
                            customPoints.showUnderResults
                          ) {
                            let string = `${customPoints.abbr}: ${
                              extra1[key] || 0
                            }-${extra2[key] || 0}. `;
                            customPointsString += string;
                          }
                        });

                        return (
                          <div
                            key={h}
                            style={{
                              background: "#eee",
                              padding: "10px 15px 10px 15px",
                              marginTop: 5,
                              marginBottom: 5,
                              borderRadius: 4,
                              width:
                                !this.state.expandedHistory && index !== 0
                                  ? `${Math.max(100 - index * 5, 0)}%`
                                  : "100%",
                              marginLeft: "auto",
                              marginRight: "auto",
                              display: "flex",
                              justifyContent: "space-between",
                              position: "relative",
                              zIndex: array.length - index,
                              cursor:
                                array.length > 1 &&
                                (index === 0 || this.state.expandedHistory)
                                  ? "pointer"
                                  : "default",
                              transition: "all 0.3s ease-in-out",
                              transform:
                                !this.state.expandedHistory && index !== 0
                                  ? `translateY(${-20 * index}px)`
                                  : "none",
                              opacity:
                                !this.state.expandedHistory && index !== 0
                                  ? Math.max(0.4, 1 - index * 0.2)
                                  : 1,
                              border: "1px solid rgb(216 216 216)",
                              height:
                                !this.state.expandedHistory && index !== 0
                                  ? "20px"
                                  : "auto",
                              overflow: "hidden",
                            }}
                            onClick={() =>
                              array.length > 1 &&
                              this.setState((prev) => ({
                                expandedHistory: !prev.expandedHistory,
                              }))
                            }
                          >
                            <div
                              style={{
                                opacity:
                                  !this.state.expandedHistory && index !== 0
                                    ? 0
                                    : 1,
                                transition: "opacity 0.3s ease-in-out",
                              }}
                            >
                              <div style={{ fontSize: 12, fontWeight: 500 }}>
                                {(scoreCleared
                                  ? languages.results.scoreClearedBy
                                  : languages.results.scoreSubmittedBy) +
                                  " " +
                                  name +
                                  (scoreCleared
                                    ? ""
                                    : ": " +
                                      (useSets
                                        ? setsString
                                        : historyItem.score1 +
                                          "-" +
                                          historyItem.score2 +
                                          (historyItem.penalties1 !== null &&
                                          historyItem.penalties2 !== null &&
                                          historyItem.penalties1 !==
                                            undefined &&
                                          historyItem.penalties2 !== undefined
                                            ? " (" +
                                              historyItem.penalties1.toString() +
                                              " - " +
                                              historyItem.penalties2.toString() +
                                              ")"
                                            : "") +
                                          "."))}
                                {!scoreCleared && customPointsString}
                              </div>
                              <div style={{ fontSize: 10, color: "#414141de" }}>
                                {dateTime}
                              </div>
                            </div>
                            {historyItem.evidenceURL && (
                              <div
                                style={{
                                  width: 25,
                                  height: 25,
                                  marginTop: "auto",
                                  marginBottom: "auto",
                                  opacity:
                                    !this.state.expandedHistory && index !== 0
                                      ? 0
                                      : 1,
                                  transition: "opacity 0.3s ease-in-out",
                                }}
                              >
                                <a
                                  href={historyItem.evidenceURL}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    style={{
                                      objectFit: "contain",
                                      width: 25,
                                      maxHeight: "100%",
                                      marginTop: 2,
                                    }}
                                    src={historyItem.evidenceURL}
                                    alt=""
                                  />
                                </a>
                              </div>
                            )}
                            {index === 0 && array.length > 1 && (
                              <KeyboardArrowDownIcon
                                style={{
                                  transform: this.state.expandedHistory
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                  transition: "transform 0.3s ease-in-out",
                                  opacity: 0.5,
                                  marginLeft: 8,
                                  alignSelf: "center",
                                }}
                              />
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
                {/* End submit history */}
              </DialogContent>
            )}
          </div>
        )}
        {this.state.value === 1 && (
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            {(this.props.tournament.playerPoints || {})["0"] !== undefined && (
              <div>
                <div style={{ fontWeight: "bold" }}>
                  {(this.props.tournament.playerPoints || {})["0"].name}
                </div>
                {(this.props.playerGoals || []).map((g, i) => {
                  return (
                    <FormControl key={i} style={{ marginTop: 7 }}>
                      <InputLabel shrink htmlFor={"goal" + i}>
                        {languages.results.goal +
                          " " +
                          (i + 1) +
                          " " +
                          this.props.playerGoalsMatch[i] || ""}
                      </InputLabel>
                      <Select
                        style={{ width: 300 }}
                        value={g}
                        onChange={this.props.handleGoalChange}
                        inputProps={{
                          name: i.toString(),
                          id: "goal" + i,
                        }}
                      >
                        <MenuItem value={""}>
                          <i>{languages.general.delete}</i>
                        </MenuItem>
                        <MenuItem value={"ownGoal1"}>
                          {languages.results.ownGoal + " - " + this.props.team1}
                        </MenuItem>
                        <MenuItem value={"ownGoal2"}>
                          {languages.results.ownGoal + " - " + this.props.team2}
                        </MenuItem>
                        {this.props.players
                          .sort((a, b) => {
                            if (a.name < b.name) {
                              return -1;
                            }
                            if (a.name > b.name) {
                              return 1;
                            }
                            return 0;
                          })
                          .map((player) => (
                            <MenuItem key={player.id} value={player.id}>
                              {player.name +
                                (player.number ? ` (${player.number})` : "") +
                                " - " +
                                (player.team === this.props.team1Id
                                  ? this.props.team1
                                  : this.props.team2)}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  );
                })}

                <FormControl style={{ marginTop: 7 }}>
                  <InputLabel shrink htmlFor="goal">
                    {languages.results.goal +
                      " " +
                      ((this.props.playerGoals || []).length + 1)}
                  </InputLabel>
                  <Select
                    style={{ width: 300 }}
                    value={""}
                    onChange={this.props.handleGoalChange}
                    inputProps={{
                      name: "new",
                      id: "goal",
                    }}
                  >
                    <MenuItem value={"ownGoal1"}>
                      {languages.results.ownGoal + " - " + this.props.team1}
                    </MenuItem>
                    <MenuItem value={"ownGoal2"}>
                      {languages.results.ownGoal + " - " + this.props.team2}
                    </MenuItem>
                    {this.props.players
                      .sort((a, b) => {
                        if (a.name < b.name) {
                          return -1;
                        }
                        if (a.name > b.name) {
                          return 1;
                        }
                        return 0;
                      })
                      .map((player) => (
                        <MenuItem key={player.id} value={player.id}>
                          {player.name +
                            (player.number ? ` (${player.number})` : "") +
                            " - " +
                            (player.team === this.props.team1Id
                              ? this.props.team1
                              : this.props.team2)}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
            )}
            {Object.keys(this.props.tournament.playerPoints || {}).map(
              (key) => {
                let points = this.props.tournament.playerPoints[key];
                if (key !== "0" && points.type !== "3") {
                  return (
                    <div key={key} style={{ marginTop: 10 }}>
                      <div style={{ fontWeight: "bold" }}>{points.name}</div>
                      {(this.props.playerPoints[key] || []).map((g, i) => {
                        return (
                          <FormControl key={i} style={{ marginTop: 7 }}>
                            <InputLabel shrink htmlFor={"points" + i}>
                              {points.abbr +
                                " " +
                                (points.type !== "2" ? i + 1 : "")}
                            </InputLabel>
                            <Select
                              style={{ width: 300 }}
                              value={g}
                              onChange={(e) => {
                                this.props.handlePlayerPointsChange(e, key);
                              }}
                              inputProps={{
                                name: i.toString(),
                                id: "points" + i,
                              }}
                            >
                              <MenuItem value={""}>
                                <i>{languages.general.delete}</i>
                              </MenuItem>
                              {this.props.players
                                .sort((a, b) => {
                                  if (a.name < b.name) {
                                    return -1;
                                  }
                                  if (a.name > b.name) {
                                    return 1;
                                  }
                                  return 0;
                                })
                                .map((player) => (
                                  <MenuItem key={player.id} value={player.id}>
                                    {player.name +
                                      (player.number
                                        ? ` (${player.number})`
                                        : "") +
                                      " - " +
                                      (player.team === this.props.team1Id
                                        ? this.props.team1
                                        : this.props.team2)}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        );
                      })}

                      {(points.type !== "2" ||
                        (this.props.playerPoints[key] || []).length < 1) && (
                        <FormControl style={{ marginTop: 7 }}>
                          <InputLabel shrink htmlFor="points">
                            {points.abbr +
                              " " +
                              (points.type !== "2"
                                ? (this.props.playerPoints[key] || []).length +
                                  1
                                : "")}
                          </InputLabel>
                          <Select
                            style={{ width: 300 }}
                            value={""}
                            onChange={(e) => {
                              this.props.handlePlayerPointsChange(e, key);
                            }}
                            inputProps={{
                              name: "new",
                              id: "points",
                            }}
                          >
                            {this.props.players
                              .sort((a, b) => {
                                if (a.name < b.name) {
                                  return -1;
                                }
                                if (a.name > b.name) {
                                  return 1;
                                }
                                return 0;
                              })
                              .map((player) => (
                                <MenuItem key={player.id} value={player.id}>
                                  {player.name +
                                    (player.number
                                      ? ` (${player.number})`
                                      : "") +
                                    " - " +
                                    (player.team === this.props.team1Id
                                      ? this.props.team1
                                      : this.props.team2)}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      )}
                    </div>
                  );
                } else {
                  return null;
                }
              }
            )}
          </DialogContent>
        )}
        <DialogActions>
          {((this.props.match.score1 !== null &&
            this.props.match.score2 !== null) ||
            Object.keys(this.props.sets).length > 0) && (
            <Button
              onClick={(e) => {
                this.props.handleSubmit(e, true);
              }}
              color="secondary"
            >
              {languages.results.clearResult}
            </Button>
          )}
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleSubmit}
            disabled={
              this.props.submitDisabled ||
              (this.props.missingTeams &&
                this.props.match.score1 !== null &&
                this.props.match.score2 !== null &&
                this.props.score1 !== null &&
                this.props.score2 !== null)
            }
            variant="contained"
            color="primary"
            type="submit"
          >
            {languages.results.save}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
